import { render, staticRenderFns } from "./checkVerifyCode.vue?vue&type=template&id=2d0bdabd&scoped=true&"
import script from "./checkVerifyCode.vue?vue&type=script&lang=js&"
export * from "./checkVerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./checkVerifyCode.vue?vue&type=style&index=0&id=2d0bdabd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bdabd",
  null
  
)

export default component.exports